<template>
  <b-overlay :show="loading">
    <DashboardHeader :current_tab="'response'"></DashboardHeader>
    <div class="response-detail-container" v-if="!loading">
      <back-button></back-button>
      <div class="responding-to-area">
        <div class="responding-to-title">
          My Partner's Post
        </div>
        <div class="response-information">
          <div class="response-image">
            <b-avatar class="photo" :src="response.submission.student.thumbnail"/>
          </div>
          <div class="info">
            <div class="user-name">{{ $options.setUserName(response.submission.student.full_name) }}</div>
            <div class="task-name">{{ response.submission.task.task_name }}</div>
            <div class="date">posted {{ response.submission.created_at | dateElapseTime }}</div>
          </div>
        </div>
        <div class="response-video">
          <video-custom
            v-if="response.submission.url"
            :src="response.submission.url"
            :video_processed="response.submission.video_processed"
            :track-video-views="true"
            :submission-id="response.submission.id"
            :classroom-id="classroomId"
          ></video-custom>
        </div>
      </div>
      <div class="responding-to-area">
        <div class="responding-to-title">
          My response
        </div>
        <div class="response-information">
          <div class="response-image">
            <b-avatar class="photo" :src="response.student.thumbnail"/>
          </div>
          <div class="info">
            <div class="user-name">{{ $options.setUserName(response.student.full_name) }}</div>
            <div class="task-name">{{ response.submission.task.task_name }}</div>
            <div class="date">posted {{ response.created_at | dateElapseTime }}</div>
          </div>
        </div>
        <div v-if="response.response_type === 'video'" class="response-video">
          <video-custom
            :src="response.url"
            :video_processed="response.video_processed"
            :hide-video="!!validStatus"
            :status-text="validStatus"
          ></video-custom>
        </div>
        <div v-else class="response-text">{{ response.text }}</div>
      </div>
      <div class="response-status">
        STATUS: {{ response.status }}
      </div>
      <div class="teacher-comment" v-if="response.teacher_comment">
        <span class="teacher-comment__label">Teacher comment:</span> {{ response.teacher_comment }}
      </div>
    </div>
  </b-overlay>
</template>

<script>
import DashboardHeader from '../../components/Dashboard/DashboardHeader'
import BackButton from '@/core/components/BackButton'
import { ClassroomService, NotificationService } from '@/core/services'
import { AppStorage, setUserName, Notifications } from '@/core/utils'
import VideoCustom from '@/core/components/video/VideoCustom'

export default {
  name: 'MyResponseDetailPage',
  setUserName: setUserName,
  components: {
    DashboardHeader,
    BackButton,
    VideoCustom
  },
  props: {
    classroomId: {
      type: Number,
      required: true
    },
    responseId: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      loading: true,
      user: AppStorage.getUser(),
      response: {}
    }
  },
  methods: {
    async init () {
      this.loading = true
      try {
        const response = await ClassroomService.getResponse(this.classroomId, this.responseId)
        this.response = response.data
        const notifications = await NotificationService.list()
        const failedVideoNotification = notifications?.data?.find((notification) => notification.status === 'unread' && notification.type === Notifications.type.studentResponseFailedVideo && notification.object_id === this.responseId)
        failedVideoNotification && NotificationService.status(failedVideoNotification.id, 'read')
      } catch (e) {
        const errorMessage = e.message ? e.message : 'Error while loading response.'
        console.log(e, errorMessage)
        await this.$bvModal.msgBoxOk(`${errorMessage} Please try again.`)
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    validStatus () {
      return (this.response.status === 'blocked' || this.response.status === 'deleted') && this.response.status
    }
  },
  created () {
    this.init()
  },
  watch: {
    classroomId: function () {
      this.init()
    },
    responseId: function () {
      this.init()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/core/stylus/variables.styl"

.response-detail-container
  max-width 625px
  margin auto

  .responding-to-area
    border-top 1px solid #DDDDDD
    border-bottom 1px solid #DDDDDD
    margin 0 20px
    padding 10px 0

    .responding-to-title
      font-weight bold
      color color-black-200
      margin-top 8px
      @media (min-width: 992px)
        font-size 20px
      @media (min-width: 768px) and (max-width: 992px)
        font-size 18px
      @media (max-width: 767px)
        font-size 16px

    .response-information
      margin-top 12px
      padding-bottom 7px
      border-bottom 1px solid #DDDDDD

      .response-image
        display inline-block
        vertical-align top
        width 90px

        .photo
          width 73px
          height 73px
          border-radius 50px
          background-repeat no-repeat
          background-size cover
          background-position center

      .info
        display inline-block
        vertical-align top
        color color-black-200
        padding-top 4px

        .user-name
          font-weight bold
          text-transform capitalize
          @media (min-width: 992px)
            font-size 16px
          @media (min-width: 768px) and (max-width: 992px)
            font-size 15px
          @media (max-width: 767px)
            font-size 14px

        .task-name
          font-weight bold
          @media (min-width: 992px)
            font-size 16px
          @media (min-width: 768px) and (max-width: 992px)
            font-size 15px
          @media (max-width: 767px)
            font-size 14px

        .date
          @media (min-width: 992px)
            font-size 16px
          @media (min-width: 768px) and (max-width: 992px)
            font-size 15px
          @media (max-width: 767px)
            font-size 14px

    .response-video
      padding 10px

      video
        width 100%
        height 395px
        background-color #F5F6FF
        border-radius 4px

      .video-overlay
        width 100%
        height 395px
        border-radius 4px

    .response-text
      font-size 14px
      color color-black-200
      padding 20px 20px 0

  .response-status
    font-size 14px
    font-weight bold
    text-transform uppercase
    color color-black-200
    margin-top 5px
    padding 0 40px
    margin-bottom 10px

  .teacher-comment
    margin 0 40px
    margin-bottom 30px
    padding 10px
    border 1.5px solid black
    background-color color-comment-background
    word-wrap break-word
    white-space pre-wrap

    &__label
      font font-opensans-semibold

</style>
